// Module
var code = "<div class=bible> <h2 class=passageref>Job 1.1</h2> <div class=bibletext> <p> </p><h2 class=plus-B>Job</h2><p></p><h2 class=plus-S>Job and His Family</h2><p><span class=cc>1</span>There was once a man in the land of Uz whose name was Job. That man was blameless and upright, one who feared God and turned away from evil. </p> </div></div>";
// Exports
module.exports = code;